<script>
  import Block from './block.svelte'
  import Row from './row.svelte'
  import Icon from './icon.svelte'
  import { stringifyStyle, calcPxNum } from './utils'
  import { onMount } from 'svelte'

  export let isPassword = false
  export let border = 1
  export let borderRadius = 0
  export let borderColor = 'darkgray'
  export let focusBorderColor = 'black'
  export let width = '10rem'
  export let height = '2rem'
  export let fontSize = '1rem'
  export let placeholder = ''
  export let color = 'black'
  export let backgroundColor = 'white'
  export let placeholderColor = 'lightgray'
  export let value = ''
  export let autoFocus = false
  export let input = null
  export let icon = undefined
  export let iconSize = '1rem'
  export let space = '0.3rem'
  export let multiline = false
  export let readonly = false
  export let resize = 'none'
  export let inputWidth = '100%'
  export let inputHeight = '100%'
  export let focusing = false
  export let autoTrim = true
  export let maxLength = 8192

  $: inputStyle = {
    width: calcPxNum(inputWidth),
    height: calcPxNum(inputHeight),
    font_size: calcPxNum(fontSize),
    border: 'none',
    outline: 'none',
    padding: '0',
    color: color,
    background_color: backgroundColor,
    '--placeholder-color': placeholderColor,
    resize: resize,
  }

  $: props = readonly ? {readonly: true, maxlength: maxLength} : {maxlength: maxLength}

  function onFocus() {
    if (readonly) return 
    focusing = true
  }

  function onBlur() {
    if (readonly) return 
    if (autoTrim && typeof(value) == 'string') value = value.trim()
    focusing = false
  }


  onMount(() => {
    if (multiline && resize != 'none') {
      // holy shit
      const observer = new ResizeObserver((entries) => {
        let fontSize = window.getComputedStyle(document.documentElement).getPropertyValue('font-size')
        fontSize = parseInt(fontSize)
        let rect = entries[0].contentRect
        if (resize == 'both' || resize == 'horizontal') {
          inputWidth = (rect.width / fontSize) + 'rem'
          width = undefined
        }
        if (resize == 'both' || resize == 'vertical') {
          inputHeight = (rect.height / fontSize) + 'rem'
          height = undefined
        }
        observer.disconnect()
      })
      
      observer.observe(input);
    }
  });
</script>

<style>
input::-webkit-input-placeholder {
  color: var(--placeholder-color);
}
textarea::-webkit-input-placeholder {
  color: var(--placeholder-color);
}
</style>

<Block 
  {border} {borderRadius} borderColor={focusing?focusBorderColor:borderColor} {backgroundColor} {width} {height} {fontSize}
  display=inline-block padding={space}
>
  <Row width=100% height=100%>
    {#if icon && !multiline}
    <Icon name={icon} size={calcPxNum(iconSize)}/>
    <Block minWidth={space}/>
    {/if}
    <!-- svelte-ignore a11y-autofocus -->
    <!-- input type cannot be dynamic when bind value -->
    <Block width=100% height=100% display=flex>
      {#if isPassword} 
      <input 
        type='password'
        style={stringifyStyle(inputStyle)}
        bind:value={value} 
        bind:this={input}
        on:keypress
        on:input
        on:change
        on:focus={onFocus}
        on:blur={onBlur}
        {placeholder}
        {...props}
      >
      {:else if multiline}
      <textarea
        type='text'
        style={stringifyStyle(inputStyle)}
        on:keypress
        on:input
        on:change
        on:focus={onFocus}
        on:blur={onBlur}
        bind:value={value}
        bind:this={input}
        {placeholder}
        {...props}
      ></textarea>
      {:else}
        {#if autoFocus}
        <input 
          type='text'
          autofocus='fuckhtml'
          style={stringifyStyle(inputStyle)}
          bind:value={value} 
          bind:this={input}
          on:keypress
          on:input
          on:change
          on:focus={onFocus}
          on:blur={onBlur}
          {placeholder}
          {...props}
        >
        {:else}
        <input 
          type='text'
          style={stringifyStyle(inputStyle)}
          bind:value={value} 
          bind:this={input}
          on:keypress
          on:input
          on:change
          on:focus={onFocus}
          on:blur={onBlur}
          {placeholder}
          {...props}
        >
        {/if}
      {/if}
    </Block>
  </Row>
  
</Block>

